import * as React from 'react'
import SpeedDial from '@mui/material/SpeedDial'
import SpeedDialIcon from '@mui/material/SpeedDialIcon'
import SpeedDialAction from '@mui/material/SpeedDialAction'

import AbcIcon from '@mui/icons-material/Abc'
import TranslateIcon from '@mui/icons-material/Translate'
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import ChatIcon from '@mui/icons-material/Chat'
import ViewKanbanIcon from '@mui/icons-material/ViewKanban'
import StyleIcon from '@mui/icons-material/Style'
import EventNoteIcon from '@mui/icons-material/EventNote'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import PermMediaIcon from '@mui/icons-material/PermMedia'
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement'

export default function HallucinationButton({
  toggleViewHallucination,
  toggleViewTranslation,
  toggleViewSpeech,
  toggleViewManyInspirations,
  toggleManyTranslationsFullView,
  toggleViewChatbot,
  toggleViewLanguagePartner,
  toggleViewKanban,
  toggleViewTaskBoard,
  toggleViewSpeechPractice,
  toggleFlashcardView,
  toggleMeetingView,
  toggleParagraphView,
  toggleMediaView,
  toggleJournalView
}) {
  const actions = [
    { icon: <AbcIcon />, name: 'Inspirations View', onClick: () => toggleViewHallucination() },
    { icon: <TranslateIcon />, name: 'Translation View', onClick: () => toggleViewTranslation() },
    { icon: <RecordVoiceOverIcon />, name: 'Speech Translation', onClick: () => toggleViewSpeech() },
    { icon: <RecordVoiceOverIcon />, name: 'Speech Practice', onClick: () => toggleViewSpeechPractice() },
    { icon: <ChatIcon />, name: 'Chatbot', onClick: () => toggleViewChatbot() },
    { icon: <ChatIcon />, name: 'Language Partner', onClick: () => toggleViewLanguagePartner() },
    { icon: <ChatIcon />, name: 'Many Translations', onClick: () => toggleManyTranslationsFullView() },
    { icon: <StyleIcon />, name: 'Flashcards', onClick: () => toggleFlashcardView() },
    { icon: <EventNoteIcon />, name: 'Meetings', onClick: () => toggleMeetingView() },
    { icon: <MenuBookIcon />, name: 'Paragraphs', onClick: () => toggleParagraphView() },
    { icon: <PermMediaIcon />, name: 'Media', onClick: () => toggleMediaView() },
    { icon: <SelfImprovementIcon />, name: 'Journal', onClick: () => toggleJournalView() }
    // { icon: <ViewKanbanIcon />, name: 'Kanban', onClick: () => toggleViewKanban() },
    // { icon: <ViewKanbanIcon />, name: 'Task Board', onClick: () => toggleViewTaskBoard() }
    // { icon: <AbcIcon />, name: 'Many Inspirations', onClick: () => toggleViewManyInspirations() }
  ]

  return (
    <SpeedDial direction="up" ariaLabel="SpeedDialLanguage" icon={<PlayArrowIcon />}>
      {actions.map((action) => (
        <SpeedDialAction key={action.name} icon={action.icon} tooltipTitle={action.name} onClick={action.onClick} />
      ))}
    </SpeedDial>
  )
}
